<template>
  <div class="position-relative">
    <span v-if="rights.includes('patient_card') && !isPatient">
      <router-link :to="{ name: 'PatientVisits', params: { id: patient.id }}">
        {{ fullName }}
      </router-link>
    </span>
    <span v-else>{{ fullName }}</span>
    <TasksBubble :tasks="tasks" class="inline-tasks"/>
  </div>
</template>

<script setup>
import { useStore} from "vuex"
import {computed} from "vue"
import TasksBubble from "@/components/parts/crm/TasksBubble.vue"

const props = defineProps({
  object: {
    type: Object
  }
})

const store = useStore()

const rights = computed(() => store.state.auth.rights)
const isPatient = computed(() => store.getters.isPatient)
const patient = computed(() => props.object.patient)
const fullName = computed(() => patient.value?.full_name || '')
const tasks = computed(() => patient.value?.patient_tasks || [])
</script>
